/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation } from 'react-query';

import { passwordReset, passwordResetCheck } from '~/api/auth';

export const useCheckToken = (options: { onError: (err: any) => void }) => {
  return useMutation(passwordResetCheck, options);
};

export const usePasswordReset = () => {
  return useMutation(passwordReset, { onError() {} });
};
